'use client';

import { c as _c } from "react/compiler-runtime";
import { format, parseISO } from 'date-fns';
import Link from 'next/link';
import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';
import { Icon } from '@/components/icon';
import { Button } from '@/components/ui/button';
import { SignUpModal } from '@/features/auth';
import { ShareButton } from '@/features/video';
import { Clock } from './clock';
type WatchHeroCtaProps = {
  isSignedIn: boolean;
  privilegeLevel: number;
  hoursLeft?: number;
  playUrl: string;
  freeAccessLabel?: string | null;
  freeAccessEndsAtIso?: string | null;
};
export function WatchHeroCta(t0) {
  const $ = _c(46);
  const {
    isSignedIn,
    privilegeLevel,
    hoursLeft,
    playUrl,
    freeAccessLabel,
    freeAccessEndsAtIso
  } = t0;
  const [showSignUp, setShowSignUp] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(null);
  let t1;
  if ($[0] !== isSignedIn) {
    t1 = (e, desiredReturnTo) => {
      if (isSignedIn) {
        return;
      }
      e.preventDefault();
      setShowSignUp(true);
    };
    $[0] = isSignedIn;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const requireAuth = t1;
  let t2;
  let t3;
  if ($[2] !== freeAccessEndsAtIso || $[3] !== freeAccessLabel || $[4] !== hoursLeft || $[5] !== isSignedIn || $[6] !== privilegeLevel) {
    t2 = () => {
      const shouldRunFreeWindowCountdown = Boolean(freeAccessEndsAtIso) && isSignedIn && privilegeLevel === 0;
      if (shouldRunFreeWindowCountdown) {
        const endsAt = new Date(freeAccessEndsAtIso as string).getTime();
        if (!Number.isFinite(endsAt)) {
          setSecondsLeft(null);
          return;
        }
        const tick = () => {
          const deltaMs = endsAt - Date.now();
          setSecondsLeft(Math.max(0, Math.ceil(deltaMs / 1000)));
        };
        tick();
        const interval = setInterval(tick, 1000);
        return () => clearInterval(interval);
      }
      const safeHoursLeft = typeof hoursLeft === "number" ? hoursLeft : 0;
      const shouldRunCountdown = !freeAccessLabel && isSignedIn && privilegeLevel === 0 && safeHoursLeft > 0;
      if (!shouldRunCountdown) {
        setSecondsLeft(null);
        return;
      }
      setSecondsLeft(Math.max(0, Math.ceil(safeHoursLeft * 60 * 60)));
      const interval_0 = setInterval(() => {
        setSecondsLeft(_temp);
      }, 1000);
      return () => clearInterval(interval_0);
    };
    t3 = [freeAccessEndsAtIso, freeAccessLabel, hoursLeft, isSignedIn, privilegeLevel];
    $[2] = freeAccessEndsAtIso;
    $[3] = freeAccessLabel;
    $[4] = hoursLeft;
    $[5] = isSignedIn;
    $[6] = privilegeLevel;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  useEffect(t2, t3);
  let t4;
  bb0: {
    if (!isSignedIn && freeAccessLabel) {
      t4 = freeAccessLabel;
      break bb0;
    }
    if (isSignedIn && privilegeLevel === 0 && freeAccessEndsAtIso) {
      const safeSecondsLeft = typeof secondsLeft === "number" ? secondsLeft : 0;
      const hours = Math.floor(safeSecondsLeft / 3600);
      const minutes = Math.floor(safeSecondsLeft % 3600 / 60);
      const seconds = safeSecondsLeft % 60;
      let t5;
      if ($[9] !== freeAccessEndsAtIso) {
        t5 = format(parseISO(freeAccessEndsAtIso), "MMM d, HH:mm 'UTC'");
        $[9] = freeAccessEndsAtIso;
        $[10] = t5;
      } else {
        t5 = $[10];
      }
      const endsAtLabel = t5;
      let t6;
      if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = <span className="text-[0.75rem] leading-none opacity-80">Free access ends in</span>;
        $[11] = t6;
      } else {
        t6 = $[11];
      }
      let t7;
      if ($[12] !== hours || $[13] !== minutes || $[14] !== seconds) {
        t7 = <Clock hours={hours} minutes={minutes} seconds={seconds} className="font-semibold text-[1.05rem] text-christ-red md:text-[1.15rem]" />;
        $[12] = hours;
        $[13] = minutes;
        $[14] = seconds;
        $[15] = t7;
      } else {
        t7 = $[15];
      }
      let t8;
      if ($[16] !== endsAtLabel) {
        t8 = <span className="text-[0.75rem] leading-none opacity-80">• Ends {endsAtLabel}</span>;
        $[16] = endsAtLabel;
        $[17] = t8;
      } else {
        t8 = $[17];
      }
      let t9;
      if ($[18] !== t7 || $[19] !== t8) {
        t9 = <span className="inline-flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-center">{t6}{t7}{t8}</span>;
        $[18] = t7;
        $[19] = t8;
        $[20] = t9;
      } else {
        t9 = $[20];
      }
      t4 = t9;
      break bb0;
    }
    if (!isSignedIn) {
      t4 = "Free for 48 hours.";
      break bb0;
    }
    if (privilegeLevel > 0) {
      t4 = null;
      break bb0;
    }
    const safeHoursLeft_0 = typeof hoursLeft === "number" ? hoursLeft : 0;
    const safeSecondsLeft_0 = typeof secondsLeft === "number" ? secondsLeft : Math.max(0, Math.ceil(safeHoursLeft_0 * 60 * 60));
    if (safeSecondsLeft_0 <= 0) {
      t4 = "Free access expired. Pay it Forward to keep watching.";
      break bb0;
    }
    const hours_0 = Math.floor(safeSecondsLeft_0 / 3600);
    const minutes_0 = Math.floor(safeSecondsLeft_0 % 3600 / 60);
    const seconds_0 = safeSecondsLeft_0 % 60;
    let t5;
    if ($[21] !== hours_0 || $[22] !== minutes_0 || $[23] !== seconds_0) {
      t5 = <Clock hours={hours_0} minutes={minutes_0} seconds={seconds_0} className="font-semibold text-[1.05rem] text-christ-red md:text-[1.15rem]" />;
      $[21] = hours_0;
      $[22] = minutes_0;
      $[23] = seconds_0;
      $[24] = t5;
    } else {
      t5 = $[24];
    }
    let t6;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <span className="mt-1 text-[0.75rem] leading-none opacity-80">of free access</span>;
      $[25] = t6;
    } else {
      t6 = $[25];
    }
    let t7;
    if ($[26] !== t5) {
      t7 = <span className="inline-flex flex-col items-center justify-center">{t5}{t6}</span>;
      $[26] = t5;
      $[27] = t7;
    } else {
      t7 = $[27];
    }
    t4 = t7;
  }
  const statusLine = t4;
  let t5;
  if ($[28] !== playUrl || $[29] !== requireAuth) {
    t5 = e_0 => requireAuth(e_0, playUrl);
    $[28] = playUrl;
    $[29] = requireAuth;
    $[30] = t5;
  } else {
    t5 = $[30];
  }
  let t6;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Icon name="play-fill-alt" className="size-14 max-w-22 md:size-20" />;
    $[31] = t6;
  } else {
    t6 = $[31];
  }
  let t7;
  if ($[32] !== playUrl || $[33] !== t5) {
    t7 = <Link href={playUrl} onClick={t5} className="stroke-4 transition-all duration-300 ease-out hover:scale-110 hover:drop-shadow-[0_0_28px_rgba(255,255,255,0.35)]">{t6}</Link>;
    $[32] = playUrl;
    $[33] = t5;
    $[34] = t7;
  } else {
    t7 = $[34];
  }
  let t8;
  if ($[35] !== statusLine) {
    t8 = statusLine && <div className="bg-black/50 px-3 py-2 font-medium text-sm backdrop-blur-md md:text-base">{statusLine}</div>;
    $[35] = statusLine;
    $[36] = t8;
  } else {
    t8 = $[36];
  }
  let t9;
  if ($[37] !== t8) {
    t9 = <div className="mt-3 flex flex-col items-center gap-2 text-center">{t8}</div>;
    $[37] = t8;
    $[38] = t9;
  } else {
    t9 = $[38];
  }
  let t10;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setShowSignUp(false);
    $[39] = t10;
  } else {
    t10 = $[39];
  }
  let t11;
  if ($[40] !== showSignUp) {
    t11 = <SignUpModal isOpen={showSignUp} onClose={t10} />;
    $[40] = showSignUp;
    $[41] = t11;
  } else {
    t11 = $[41];
  }
  let t12;
  if ($[42] !== t11 || $[43] !== t7 || $[44] !== t9) {
    t12 = <div className="flex flex-col items-center">{t7}{t9}{t11}</div>;
    $[42] = t11;
    $[43] = t7;
    $[44] = t9;
    $[45] = t12;
  } else {
    t12 = $[45];
  }
  return t12;
}
function _temp(prev) {
  if (prev === null) {
    return null;
  }
  return Math.max(0, prev - 1);
}
type WatchHeroActionsProps = {
  isSignedIn: boolean;
};
export function WatchHeroActions(t0) {
  const $ = _c(16);
  const {
    isSignedIn
  } = t0;
  const [showSignUp, setShowSignUp] = useState(false);
  let t1;
  if ($[0] !== isSignedIn) {
    t1 = (e, desiredReturnTo) => {
      if (isSignedIn) {
        return;
      }
      e.preventDefault();
      setShowSignUp(true);
    };
    $[0] = isSignedIn;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const requireAuth = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="md:mb-1 md:self-end"><ShareButton /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Button asChild={true} variant="ghost" className="flex h-auto w-auto items-center justify-start gap-2 p-0 font-light uppercase transition-opacity hover:opacity-90 md:justify-end"><Link href="/watch/trailer"><Icon name="play" className="size-4 max-w-4" /><span className="relative top-[0.1rem]">Watch Trailer</span></Link></Button>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== requireAuth) {
    t4 = e_0 => requireAuth(e_0, "/watch/intro");
    $[4] = requireAuth;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Icon name="play" className="size-4 max-w-4" />;
    t6 = <span className="relative top-[0.1rem]">Watch Intro</span>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4) {
    t7 = <Button asChild={true} variant="ghost" className="flex h-auto w-auto items-center justify-start gap-2 p-0 font-light uppercase transition-opacity hover:opacity-90 md:justify-end"><Link href="/watch/intro" onClick={t4}>{t5}{t6}</Link></Button>;
    $[8] = t4;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setShowSignUp(false);
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== showSignUp) {
    t9 = <SignUpModal isOpen={showSignUp} onClose={t8} />;
    $[11] = showSignUp;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t7 || $[14] !== t9) {
    t10 = <div className="flex w-full flex-wrap items-center justify-start gap-x-6 gap-y-3 md:flex-col md:flex-nowrap md:items-end md:justify-start md:gap-3">{t2}{t3}{t7}{t9}</div>;
    $[13] = t7;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
}